export const MARKUP = 300;
export const MARKUP_CLASS = 'markup';
export const MARKUP_FAST = 600;
export const MARKUP_FAST_CLASS = 'markup-faster';
export const MARKUP_NUMBER118 = 1200;
export const MARKUP_NUMBER118_CLASS = 'markup-118';
export const PERCENTAGE = "PERCENTAGE";
export const PERCENTAGE_CLASS = "markup-percentage";
export const PREMIUM_BTOC = "PREMIUM_BTOC";
export const PREMIUM_BTOC_CLASS = "markup-BtoC";

export function getMarkup() {
    return [
        { value: MARKUP, label: '3 euros', class: MARKUP_CLASS },
        { value: MARKUP_FAST, label: '6 euros', class: MARKUP_FAST_CLASS },
        { value: MARKUP_NUMBER118, label: '12 euros', class: MARKUP_NUMBER118_CLASS },
        { value: PERCENTAGE, label: 'commission 10%', class: PERCENTAGE_CLASS },
        { value: PREMIUM_BTOC, label: 'Abo premium BtoC', class: PREMIUM_BTOC_CLASS },
    ];
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SelectList/StatusMarkup.js